module.exports = "/_next/static/images/69d3b640bf1ce240e62ddbdf74fbd3cb-sarlaft-xs.png";